module.exports = __webpack_public_path__ + "static/media/ranger-fig-1.badbce67.jpg";